import {
  PosMultiSelect,
  PosMultiSelectProps,
} from 'src/core/POS/PosMultiSelect';
import { useUserGroups } from 'src/hooks/useUserGroups';
import { useUserHasConsignorMasterUI } from 'src/hooks/useUserIsConsignorMasterUI';

export const UserGroupMultiSelector = ({
  consigneeSellerAccountId,
  ...props
}: Omit<PosMultiSelectProps, 'valueOptionsContent'> & {
  consigneeSellerAccountId?: string | null;
}) => {
  const { userGroups, isLoading } = useUserGroups();
  const hasConsignorMasterUI = useUserHasConsignorMasterUI();

  if (!hasConsignorMasterUI) {
    consigneeSellerAccountId = null;
  }

  const userGroupsContentSelect = (userGroups ?? [])
    .filter(
      (ug) =>
        consigneeSellerAccountId == null ||
        ug.consigneeSellerAccountId === consigneeSellerAccountId
    )
    .reduce<Record<string, string>>((acc, userGroup) => {
      acc[userGroup.userGroupId.toString()] = userGroup.userGroupName;
      return acc;
    }, {});

  return (
    <PosMultiSelect
      {...props}
      loading={isLoading}
      valueOptionsContent={userGroupsContentSelect}
    />
  );
};
